import { fetchAuthSession } from 'aws-amplify/auth';
import { getUserCometchatCreds, provisionCometchatUser } from './cometchatApi';

let cachedSession = null;

/**
 * Provision CometChat user and cache creds for SDK login.
 * Call after Cognito login — does not require CometChat SDK to be installed.
 */
export const bootstrapCometchatSession = async () => {
  try {
    let credsResponse;
    try {
      credsResponse = await getUserCometchatCreds();
    } catch (error) {
      if (error.status === 404) {
        await provisionCometchatUser();
        credsResponse = await getUserCometchatCreds();
      } else {
        throw error;
      }
    }

    const { tokens } = await fetchAuthSession();
    const sub = tokens?.idToken?.payload?.sub;
    const userCreds = credsResponse?.user_creds ?? credsResponse;
    const authToken = userCreds?.cometchat_auth_token;

    if (!sub || !authToken) {
      console.warn('[cometchatSession] Missing sub or auth token after bootstrap');
      return null;
    }

    cachedSession = { uid: sub, authToken, userCreds };

    // When @cometchat/chat-sdk-javascript is installed:
    // await CometChat.login(sub, authToken);

    return cachedSession;
  } catch (error) {
    console.warn('[cometchatSession] Bootstrap failed:', error);
    return null;
  }
};

export const getCachedCometchatSession = () => cachedSession;

export const clearCometchatSession = () => {
  cachedSession = null;
};

export default {
  bootstrapCometchatSession,
  getCachedCometchatSession,
  clearCometchatSession,
};
